// extracted by mini-css-extract-plugin
module.exports = {"divisor":"divisor_divisor__OEuXy","noBottomMargin":"divisor_noBottomMargin__BIXvT","noTopMargin":"divisor_noTopMargin__G7o6v"};